/* eslint-disable */
import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    header: {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "flex-end",
      paddingTop: 40,
      paddingBottom: 16,
    },
    leftSide: {
      flex: 1,
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "flex-end",
    },
    rightSide: {
      flex: 1,
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
    },
    title: {
      fontWeight: "bold" as any,
      fontSize: "22px",
      lineHeight: "29px",
    },
    more: {
      color: "#1C8AB5",
      fontSize: "14px",
      lineHeight: "20px",
      textDecorationLine: "underline",
      padding: 0,
      margin: 0,
      border: "none",
      "&:hover": {
        padding: 0,
        border: "none",
        color: "#21A0D2",
      },
      "&:visited": {
        color: "#006c97",
      },
    },
  });

export const useStyles = makeStyles(styles);
